import React, { useEffect, useState } from "react";
import styled from 'styled-components';
import { Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faToggleOn, faToggleOff } from '@fortawesome/free-solid-svg-icons';
import PropTypes from "prop-types";
import InputSelect from "../../../../components/modalComponents/InputSelect";
import { useManageGetRequest } from "../../../../hooks/useManageGetRequest/useManageGetRequest";
import { useManagePostRequest } from "../../../../hooks/useManagePostRequest/useManagePostRequest";
import { cuadroRequerimientosActivarInactivarRestriccionCampanaAPI, cuadroRequerimientosEditarBloqueoCampanaAPI, cuadroRequerimientosEditarMaximoDeRangoHorasCampanaAPI, cuadroRequerimientosEditarMinimoDeRangoHorasCampanaAPI, cuadroRequerimientosEditarRestriccionCampanaSedesExcluidasAPI, cuadroRequerimientosEditarRestriccionCampanaSedesIncluidasAPI, cuadroRequerimientosEliminarBloqueoCampanaAPI, cuadroRequerimientosGetAllCursosStartsWithSoloAPI, cuadroRequerimientosGetAllGradosAPI, cuadroRequerimientosGetRangoHorasByIdCampanaAPI, cuadroRequerimientosGetRelatedDataTypeWithDescripcionAPI, cuadroRequerimientosGetSedesWithTodosOptionAPI, cuadroRequerimientosGetTipoBloqueoCampanaAPI, cuadroRequerimientosListarBloqueoCampanaAPI, cuadroRequerimientosListarRestriccionCampanaAPI, cuadroRequerimientosRegistrarBloqueoCampanaAPI } from "../../../../consumers/backendApisUrls";
import { ID_TIPO_NIVEL_MODALIDADDEDICTADO } from "../../../../constants/hardCodedConstants";
import {PrimaryActionButtonForPage} from "../../styledComponents/styledComponents";
import EditableCell from "./parametrosCampanaComponents/EditableCell";
import { v4 as uuidv4 } from 'uuid';

const Styles = styled.div`
    padding: 10px;
  
    h5 {
        font-family: $font-family-GothamBold;
        font-style: normal;
        font-weight: bold;
        font-size: 15px;
        display: flex;
        align-items: center;
        color: #1976d2;
    }

    .table-container {
        background: white;
        border: 1px solid #dee2e6;
        border-radius: 4px;
        margin-top: 10px;
    }

    .custom-table {
        width: 100%;
        margin-bottom: 0;
        
        th {
            background-color: #f1f1f1;
            color: #555;
            font-weight: 600;
            text-align: center;
            vertical-align: middle;
            border-bottom: 1px solid #dee2e6;
        }

        td {
            vertical-align: middle !important;
            color: #666;
            border-bottom: 1px solid #dee2e6;
        }

        .col-obs {
            font-weight: bold;
            color: #333;
        }
    }

    .tag-item {
        display: inline-block;
        background-color: #e0e0e0;
        padding: 2px 8px;
        border-radius: 12px;
        margin: 2px;
        font-size: 0.85em;
        color: #333;
    
        .remove-tag {
            margin-left: 5px;
            cursor: pointer;
            color: #666;
            &:hover { color: #333; }
        }
    }

    .btn-action {
        display: flex;
        align-items: center;
        border: none;
        border-radius: 4px;
        padding: 6px 15px;
        cursor: pointer;
        transition: background-color 0.2s;
        font-family: GothamLight;
        font-size: 14px;
        background-color: #d8d8d8;
        color: #fff;

        &:focus {
            outline: none;
        }
        
        &:hover {
            background-color: #1890ff;
        }
    }

    .select-container {
        width: 100%;
        margin-bottom: 0 !important;
        
        & > div {
            width: 100% !important;
            margin-bottom: 0 !important;
        } 
    }
    
    .action-icon {
        cursor: pointer;
        margin: 0 8px;
        
        &:hover {
            color: #1890ff;
        }
    }

    @media (max-width: 992px) {
        .table {
            display: block;
        }
        .egssth .description {
            border: 0 !important;
        }
    }
`;

export default function ParametrosCampana({ campana, isReadOnly }) {
    const [executeManageGetRequest] = useManageGetRequest();
    const [executeManagePostRequest] = useManagePostRequest();

    const [asignacionBloques, setAsignacionBloques] = useState([]);
    const [bloqueos, setBloqueos] = useState([]);
    const [restricciones, setRestricciones] = useState([]);

    const [optionsSedes, setOptionsSedes] = useState([]);
    const [optionsTipo, setOptionsTipo] = useState([]);
    const [optionsSubtipo, setOptionsSubtipo] = useState([]);
    const [optionsCursos, setOptionsCursos] = useState([]);

    const [selectedTipo, setSelectedTipo] = useState(null);
    const [selectedSubtipo, setSelectedSubtipo] = useState(null);
    const [selectedCursos, setSelectedCursos] = useState([]);


    const handleSaveMinimo = async (IdRangoHorasCampana, field, Minimo) => {
        const payload = {
            IdRangoHorasCampana,
            Minimo
        }
        await executeManagePostRequest(
            cuadroRequerimientosEditarMinimoDeRangoHorasCampanaAPI(),
            payload,
            async (res) => {
                await refreshRangosHoras();
            },
            true,
            async (err) => {
                 await refreshRangosHoras();
            },
            true
        );
    };

    const handleSaveMaximo = async (IdRangoHorasCampana, field, Maximo) => {
        const payload = {
            IdRangoHorasCampana,
            Maximo
        }
        await executeManagePostRequest(
            cuadroRequerimientosEditarMaximoDeRangoHorasCampanaAPI(),
            payload,
            async (res) => {
                await refreshRangosHoras();
            },
            true,
            async  (err) => {
                await refreshRangosHoras();
            },
            true
        );
    };

    const handleAsignacionChange = async (IdRangoHorasCampana, field, val) => {
        const value = parseInt(val) || 0;;
        if (field === 'Minimo') {
            await handleSaveMinimo(IdRangoHorasCampana, field, value);
        }
        if (field === 'Maximo') {
            await handleSaveMaximo(IdRangoHorasCampana, field, value);
        }
    };

    const handleBloqueoChange = async (id, selected) => {
        const payload = {
            IdBloqueoCampana: id,
            IdsCursos: selected.map(item => item.value)
        }
        await executeManagePostRequest(
            cuadroRequerimientosEditarBloqueoCampanaAPI(),
            payload,
            (res) => {
                setBloqueos(prev => prev.map(item => item.IdBloqueoCampana === id ? { ...item, Cursos: selected } : item));
            },
            true,
            (err) => {
                console.log(err);
            },
            true
        );
    };

    const handleSaveSedesIncluidas = async (IdRestriccionCampana, field, selected) => {
        const payload = {
            IdRestriccionCampana,
            IdsSedesIncluidas: selected.map(item => item.value)
        }
        await executeManagePostRequest(
            cuadroRequerimientosEditarRestriccionCampanaSedesIncluidasAPI(),
            payload,
            (res) => {
                setRestricciones(prev => prev.map(item => item.IdRestriccionCampana === IdRestriccionCampana ? { ...item, [field]: selected } : item));
            },
            true,
            (err) => {
                console.log(err);
            },
            true
        );
    };

    const handleSaveSedesExcluidas = async (IdRestriccionCampana, field, selected) => {
        const payload = {
            IdRestriccionCampana,
            IdsSedesExcluidas: selected.map(item => item.value)
        }
        await executeManagePostRequest(
            cuadroRequerimientosEditarRestriccionCampanaSedesExcluidasAPI(),
            payload,
            (res) => {
                setRestricciones(prev => prev.map(item => item.IdRestriccionCampana === IdRestriccionCampana ? { ...item, [field]: selected } : item));
            },
            true,
            (err) => {
                console.log(err);
            },
            true
        );
    };

    const handleRestriccionChange = (IdRestriccionCampana, field, selected) => {
        if (field === 'SedesIncluidas') {
            handleSaveSedesIncluidas(IdRestriccionCampana, field, selected);
        }
        if (field === 'SedesExcluidas') {
            handleSaveSedesExcluidas(IdRestriccionCampana, field, selected);
        }
    };

    const refreshRangosHoras = async () => {
        await executeManageGetRequest(
            cuadroRequerimientosGetRangoHorasByIdCampanaAPI(campana.IdCampana),
            ({ data }) => {
                setAsignacionBloques(
                    (data ?? []).map(item => ({ ...item }))
                );
            },
            false
        );
    };

    const handleLoadGrid = async () => {
        const responseGetRangoHorasByIdCampana = executeManageGetRequest(cuadroRequerimientosGetRangoHorasByIdCampanaAPI(campana.IdCampana), (res) => { }, false);
        const responseGetTipoBloqueoCampana = executeManageGetRequest(cuadroRequerimientosGetTipoBloqueoCampanaAPI(), (res) => { }, false);
        const responseGetAllCursosStartsWithSolo = executeManageGetRequest(cuadroRequerimientosGetAllCursosStartsWithSoloAPI(), (res) => { }, false);
        const responseListarBloqueoCampana = executeManageGetRequest(cuadroRequerimientosListarBloqueoCampanaAPI(campana.IdCampana), (res) => { }, false);
        const responseGetSedesWithTodosOption = executeManageGetRequest(cuadroRequerimientosGetSedesWithTodosOptionAPI(), (res) => { }, false);
        const responseListarRestriccionCampana = executeManageGetRequest(cuadroRequerimientosListarRestriccionCampanaAPI(campana.IdCampana), (res) => { }, false);
        await Promise.all([
            responseGetRangoHorasByIdCampana,
            responseGetTipoBloqueoCampana,
            responseGetAllCursosStartsWithSolo,
            responseListarBloqueoCampana,
            responseGetSedesWithTodosOption,
            responseListarRestriccionCampana
        ]).then(async (res) => {
            const dataRangoHoras = (await res[0].data ?? []);
            setAsignacionBloques([...dataRangoHoras]);
            const dataTipoBloqueoCampana = (await res[1].data ?? []).map(item => ({ value: item.Value, label: item.Text }));
            setOptionsTipo(dataTipoBloqueoCampana);
            const dataCursos = (await res[2].data ?? []).map(item => ({ value: item.Value, label: item.Text }));
            setOptionsCursos(dataCursos);
            const dataBloqueoCampana = (await res[3].data ?? []);
            const dataBloqueos = dataBloqueoCampana.map(item => ({ ...item, Cursos: (item.Cursos ?? []).map(curso => ({ value: curso.Value, label: curso.Text })) }));
            setBloqueos(dataBloqueos);
            const dataSedes = (await res[4].data ?? []).map(item => ({ value: item.Value, label: item.Text }));
            setOptionsSedes(dataSedes);
            const dataRestriccionCampana = (await res[5].data ?? []);
            const dataRestricciones = dataRestriccionCampana.map(item => ({
                ...item,
                SedesIncluidas: (item.SedesIncluidas ?? []).map(sedeIncluida => ({ value: sedeIncluida.Value, label: sedeIncluida.Text })),
                SedesExcluidas: (item.SedesExcluidas ?? []).map(sedeExcluida => ({ value: sedeExcluida.Value, label: sedeExcluida.Text }))
            }));
            setRestricciones(dataRestricciones);
        });
    }



    const handleLoadOptionsSubtipo = async (object) => {
        const apiGetRelatedDataTypeWithDescripcion = cuadroRequerimientosGetRelatedDataTypeWithDescripcionAPI(ID_TIPO_NIVEL_MODALIDADDEDICTADO);
        const apiGetAllGrados = cuadroRequerimientosGetAllGradosAPI();
        const api = object.value === 1 ? apiGetRelatedDataTypeWithDescripcion : (object.value === 2 ? apiGetAllGrados : '');
        await executeManageGetRequest(
            api,
            async (res) => {
                const data = (await res.data ?? []).map(item => ({ value: item.Value, label: item.Text }));
                setOptionsSubtipo(data);
            },
            false
        );
    }

    const handleTipoChange = async (value) => {
        setSelectedTipo(value);
        setSelectedSubtipo(null);
        await handleLoadOptionsSubtipo(value);
    };

    const handleSubtipoChange = (value) => {
        setSelectedSubtipo(value);
    };

    const handleCursosChange = (value) => {
        setSelectedCursos(value);
    };

    const refetchDataBloqueos = async () => {
        await executeManageGetRequest(
            cuadroRequerimientosListarBloqueoCampanaAPI(campana.IdCampana),
            async (res) => {
                const dataBloqueoCampana = (await res.data ?? []);
                const data = dataBloqueoCampana.map(item => ({ ...item, Cursos: (item.Cursos ?? []).map(curso => ({ value: curso.Value, label: curso.Text })) }));
                setBloqueos(data);
            },
            false
        );
    };

    const handleAgregarBloque = async () => {

        const payload = {
            IdCampana: campana.IdCampana,
            ...(
                selectedTipo ? (selectedTipo.value === 1 ? { IdNivel: (selectedSubtipo ? selectedSubtipo.value : 0) } : (
                    selectedTipo.value === 2 ? { IdGrado: (selectedSubtipo ? selectedSubtipo.value : 0) } : {}
                )) : {}
            ),
            IdsCursos: selectedCursos && selectedCursos.length > 0 ? selectedCursos.map(item => item.value) : []
        };
        await executeManagePostRequest(
            cuadroRequerimientosRegistrarBloqueoCampanaAPI(),
            payload,
            async (res) => {
                setSelectedTipo(null);
                setSelectedSubtipo(null);
                setSelectedCursos([]);
                setOptionsSubtipo([])
                await refetchDataBloqueos();
            },
            true,
            (err) => {
                console.log(err);
            },
            true
        );
    };

    const handleDeleteBloqueo = async (item) => {
        await executeManagePostRequest(
            cuadroRequerimientosEliminarBloqueoCampanaAPI(item.IdBloqueoCampana),
            {},
            async (res) => {
                await refetchDataBloqueos();
            },
            true,
            (err) => {
                console.log(err);
            },
            true
        );
    };

    const handleToggleRestriccion = async (IdRestriccionCampana, estado) => {
        if (isReadOnly === true) return;
        await executeManagePostRequest(
            cuadroRequerimientosActivarInactivarRestriccionCampanaAPI(IdRestriccionCampana),
            {},
            async (res) => {
                const newEstado = estado === 'Activo' ? false : true;
                setRestricciones(prev => prev.map(item => item.IdRestriccionCampana === IdRestriccionCampana ? { ...item, EsActivo: newEstado } : item));
            },
            true,
            (err) => {
                console.log(err);
            },
            true
        );
    }

    useEffect(() => {
        handleLoadGrid();
    }, [campana]);

    return (
        <Styles>
            <h5 style={{ paddingBottom: '10px', borderBottom: '1px solid #dee2e6' }}>Asignación de bloques por grado</h5>
            <div className="table-container">
                <Table bordered hover size="sm" className="custom-table">
                    <thead className="listar-thead">
                        <tr>
                            <th className="text-left" style={{ paddingLeft: '20px', width: '40%' }}>
                                <div className="flex font-gothan-medium">
                                    Grado / Nivel / Categoría
                                </div>
                            </th>
                            <th style={{ width: '20%' }}>
                                <div className="flex font-gothan-medium">
                                    Mínimo
                                </div>
                            </th>
                            <th style={{ width: '20%' }}>
                                <div className="flex font-gothan-medium">
                                    Máximo
                                </div>
                            </th>
                            <th className="text-left" style={{ paddingLeft: '20px', width: '20%' }}>
                                <div className="flex font-gothan-medium">
                                    Observaciones
                                </div>
                            </th>
                        </tr>
                    </thead>
                        <tbody className="listar-tbody">
                        {asignacionBloques.map((item, index) => (
                            <tr key={`${uuidv4()}`}>
                                <td className="text-left" style={{ paddingLeft: '20px' }}>{item.Nombre}</td>
                                <td>
                                    <div style={{ width: '80px', margin: '0 auto' }}>
                                        <EditableCell key={`${item.IdRangoHorasCampana}-${item.Minimo}-${item.Maximo}${index}`} value={item.Minimo} updateDB={async (val) => handleAsignacionChange(item.IdRangoHorasCampana, 'Minimo', val)} isReadOnly={isReadOnly} />
                                    </div>
                                </td>
                                <td>
                                    <div style={{ width: '80px', margin: '0 auto' }}>
                                        <EditableCell key={`${item.IdRangoHorasCampana}-${item.Minimo}-${item.Maximo}${index}`} value={item.Maximo} updateDB={async (val) => handleAsignacionChange(item.IdRangoHorasCampana, 'Maximo', val)}  isReadOnly={isReadOnly} />
                                    </div>
                                </td>
                                <td className="text-left col-obs" style={{ paddingLeft: '20px' }}>{item.Observaciones}</td>
                            </tr>
                        ))}
                        </tbody>



                </Table>
            </div>
            <div style={{ fontSize: '12px', color: '#666' }}>
                *Ingresa el número y presiona Enter para guardar.
            </div>

            <h5 style={{ paddingTop: '20px' }}>Bloqueos</h5>

            {isReadOnly === false &&
                <table style={{ width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '20%', padding: '10px', cursor: 'default' }}>
                                <InputSelect
                                    label="Tipo:"
                                    name="tipo"
                                    placeholder="Seleccionar"
                                    options={optionsTipo}
                                    value={selectedTipo}
                                    onChange={async (e) => await handleTipoChange(e.target.value)}
                                    isRequired={false}
                                    direction="column"
                                />
                            </td>
                            <td style={{ width: '20%', padding: '10px', cursor: 'default' }}>
                                <InputSelect
                                    label="Subtipo:"
                                    name="grado"
                                    placeholder="Seleccionar"
                                    options={optionsSubtipo}
                                    value={selectedSubtipo}
                                    onChange={(e) => handleSubtipoChange(e.target.value)}
                                    isRequired={false}
                                    direction="column"
                                />
                            </td>
                            <td style={{ width: '40%', padding: '10px', cursor: 'default' }}>
                                <InputSelect
                                    label="Cursos:"
                                    name="cursos"
                                    placeholder="Seleccionar"
                                    options={optionsCursos}
                                    value={selectedCursos}
                                    onChange={(e) => handleCursosChange(e.target.value)}
                                    isMulti={true}
                                    isRequired={false}
                                    direction="column"
                                />
                            </td>
                            <td style={{ width: '20%', padding: '10px', verticalAlign: 'middle', }}>
                                <PrimaryActionButtonForPage onClick={async () => handleAgregarBloque()} disabled={selectedTipo === null}>
                                    Agregar
                                </PrimaryActionButtonForPage>
                            </td>
                        </tr>
                    </tbody>
                </table>
            }
            <div className="table-container">
                <Table bordered hover size="sm" className="custom-table">
                    <thead className="listar-thead">
                        <tr>
                            <th className="text-left" style={{ paddingLeft: '20px', width: '40%' }}>
                                <div className="font-gothan-medium">Grado / Modalidad de dictado</div>
                            </th>
                            <th style={{ width: '50%' }}>
                                <div className="font-gothan-medium">Área y Curso</div>
                            </th>
                            <th style={{ width: '10%' }}>
                                <div className="font-gothan-medium">Acciones</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody className="listar-tbody">
                        {bloqueos.map(item => (
                            <tr key={item.id}>
                                <td className="text-left" style={{ paddingLeft: '20px' }}>{item.GradoNivel}</td>
                                <td className="text-left">
                                    <div className="select-container">
                                        <InputSelect
                                            label=""
                                            name="areascurso"
                                            options={optionsCursos}
                                            value={item.Cursos}
                                            onChange={async (e) => await handleBloqueoChange(item.IdBloqueoCampana, e.target.value)}
                                            isMulti={true}
                                            direction="row"
                                            isDisabled={isReadOnly}
                                        />
                                    </div>
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    {item.PuedeEliminar && (
                                        <FontAwesomeIcon icon={faTrash} className="action-icon" onClick={async () => await handleDeleteBloqueo(item)} />
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            <h5 style={{ paddingTop: '20px', paddingBottom: '10px', borderBottom: '1px solid #dee2e6' }}>Restricciones y consideraciones adicionales</h5>
            <div className="table-container">
                <Table bordered hover size="sm" responsive={true} className="custom-table">
                    <thead className="listar-thead">
                        <tr>
                            <th className="text-left" style={{ paddingLeft: '20px', width: '50%' }}>
                                <div className="font-gothan-medium">Descripción</div>
                            </th>
                            <th style={{ width: '20%' }}>
                                <div className="font-gothan-medium">Incluyo</div>
                            </th>
                            <th style={{ width: '20%' }}>
                                <div className="font-gothan-medium">Excluyo</div>
                            </th>
                            <th style={{ width: '10%' }}>
                                <div className="font-gothan-medium">Activo</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody className="listar-tbody">
                        {restricciones.map(item => (
                            <tr key={item.IdRestriccionCampana}>
                                <td className="text-left" style={{ paddingLeft: '20px', fontSize: '13px' }}>{item.Descripcion}</td>
                                <td className="text-left" style={{ verticalAlign: 'top' }}>
                                    <div className="select-container">
                                        <InputSelect
                                            label=""
                                            name="SedesIncluidas"
                                            options={optionsSedes}
                                            value={item.SedesIncluidas}
                                            onChange={(e) => handleRestriccionChange(item.IdRestriccionCampana, 'SedesIncluidas', e.target.value)}
                                            isMulti={true}
                                            direction="column"
                                            isDisabled={isReadOnly}
                                        />
                                    </div>
                                </td>
                                <td className="text-left" style={{ verticalAlign: 'top' }}>
                                    <div className="select-container">
                                        <InputSelect
                                            label=""
                                            name="SedesExcluidas"
                                            options={optionsSedes}
                                            value={item.SedesExcluidas}
                                            onChange={(e) => handleRestriccionChange(item.IdRestriccionCampana, 'SedesExcluidas', e.target.value)}
                                            isMulti={true}
                                            direction="column"
                                            isDisabled={isReadOnly}
                                        />
                                    </div>
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    {!item.EsActivo && (
                                        <FontAwesomeIcon
                                            icon={faToggleOff}
                                            title="Inactivo"
                                            style={{ color: '#eb5757', fontSize: '18px' }}
                                            aria-disabled={item.PuedeInactivar}
                                            onClick={async () => await handleToggleRestriccion(item.IdRestriccionCampana, 'Inactivo')} />
                                    )}
                                    {item.EsActivo && (
                                        <FontAwesomeIcon
                                            icon={faToggleOn}
                                            title="Activo"
                                            style={{ color: '#27ae60', fontSize: '18px' }}
                                            aria-disabled={item.PuedeActivar}
                                            onClick={async () => await handleToggleRestriccion(item.IdRestriccionCampana, 'Activo')} />
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </Styles>
    );
}

ParametrosCampana.propTypes = {
    campana: PropTypes.object.isRequired,
};
